/**
 * External legal documents referenced by the onboarding consent checkboxes
 * ("Review our terms", Figma MVP-DESIGNES 9236:2369).
 *
 * The Terms & Conditions text itself is shown inline from
 * `onboardingTerms.txt`; these URLs only add a "Read ..." link next to the
 * matching checkbox.  An empty string renders the plain label with no link,
 * which is the current state: the public URLs are not published yet.
 */
export const TERMS_URL = '';
export const PRIVACY_POLICY_URL = '';
